import { useEffect, useState } from "react";

const CHAMPS = [
  ["nom_groupe", "Nom du groupe", true],
  ["code_groupe_propose", "Code groupe proposé", true],
  ["nom_structure", "Nom société / structure"],
  ["adresse", "Adresse"],
  ["code_postal", "Code postal"],
  ["ville", "Ville"],
  ["telephone", "Téléphone"],
  ["nom_administrateur", "Nom administrateur", true],
  ["prenom_administrateur", "Prénom administrateur", true],
  ["fonction_administrateur", "Fonction"],
  ["email_administrateur", "Email administrateur", true, "email"],
  ["telephone_administrateur", "Téléphone administrateur"]
];

const formulaireVide = Object.fromEntries(CHAMPS.map(([nom]) => [nom, ""]));

function QuestionnaireDemandeGroupe({ clientSupabase, token }) {
  const [formulaire, setFormulaire] = useState({ ...formulaireVide, commentaire: "" });
  const [destinataire, setDestinataire] = useState("");
  const [statut, setStatut] = useState("CHARGEMENT");
  const [message, setMessage] = useState("");
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    let actif = true;
    async function charger() {
      const { data, error } = await clientSupabase.rpc("demande_groupe_publique_lire", {
        p_token: token
      });
      if (!actif) return;
      const demande = data?.[0];
      if (error || !demande) {
        setStatut("INVALIDE");
        setMessage("Ce lien est invalide ou a expiré.");
        return;
      }
      setDestinataire(demande.nom_destinataire || "");
      setStatut(demande.statut);
      if (demande.statut === "EN_ATTENTE") {
        setFormulaire((ancien) => ({
          ...ancien,
          ...Object.fromEntries(
            [...CHAMPS.map(([nom]) => nom), "commentaire"].map((nom) => [nom, demande[nom] || ""])
          )
        }));
      } else {
        setMessage(
          demande.statut === "A_VALIDER"
            ? "Votre demande a bien été transmise au superviseur."
            : "Cette demande est clôturée."
        );
      }
    }
    charger();
    return () => { actif = false; };
  }, [clientSupabase, token]);

  const modifier = (nom, valeur) => {
    setFormulaire((ancien) => ({
      ...ancien,
      [nom]: nom === "code_groupe_propose" ? valeur.toUpperCase() : valeur
    }));
  };

  const soumettre = async (event) => {
    event.preventDefault();
    if (envoi) return;
    setEnvoi(true);
    setMessage("");
    const parametres = { p_token: token, p_commentaire: formulaire.commentaire };
    CHAMPS.forEach(([nom]) => { parametres[`p_${nom}`] = formulaire[nom]; });
    const { error } = await clientSupabase.rpc("demande_groupe_publique_soumettre", parametres);
    setEnvoi(false);
    if (error) {
      setMessage("Impossible d'enregistrer la demande. Vérifiez les informations ou la validité du lien.");
      return;
    }
    setStatut("A_VALIDER");
    setMessage("Votre demande a bien été transmise au superviseur.");
  };

  const page = { minHeight: "100vh", background: "#f2f4f7", padding: 24, fontFamily: "Arial, sans-serif" };
  const carte = { maxWidth: 820, margin: "0 auto", background: "white", padding: 28, borderRadius: 10 };
  const grille = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 };
  const input = { display: "block", width: "100%", padding: 10, marginTop: 5, boxSizing: "border-box" };

  if (statut !== "EN_ATTENTE") {
    return <main style={page}><section style={carte}><h2>DEMANDE DE CRÉATION D'UN GROUPE</h2><p>{message || "Chargement..."}</p></section></main>;
  }

  return (
    <main style={page}>
      <section style={carte}>
        <h2>DEMANDE DE CRÉATION D'UN GROUPE</h2>
        <p>Bonjour {destinataire}, merci de compléter ce questionnaire simple. Le groupe ne sera créé qu'après validation du superviseur.</p>
        <form onSubmit={soumettre}>
          <div style={grille}>
            {CHAMPS.map(([nom, libelle, obligatoire, type]) => (
              <label key={nom}>{libelle}{obligatoire ? " *" : ""}
                <input
                  required={obligatoire}
                  type={type || "text"}
                  value={formulaire[nom]}
                  onChange={(e) => modifier(nom, e.target.value)}
                  style={input}
                />
              </label>
            ))}
          </div>
          <label style={{ display: "block", marginTop: 14 }}>Commentaire libre
            <textarea value={formulaire.commentaire} onChange={(e) => modifier("commentaire", e.target.value)} rows="5" style={input} />
          </label>
          {message && <p style={{ color: "#b71c1c" }}>{message}</p>}
          <button disabled={envoi} type="submit" style={{ marginTop: 18, padding: "11px 18px", background: "#1565c0", color: "white", border: 0, borderRadius: 6 }}>
            {envoi ? "ENVOI..." : "TRANSMETTRE LA DEMANDE"}
          </button>
        </form>
      </section>
    </main>
  );
}

export default QuestionnaireDemandeGroupe;
